import { Component, OnInit, Input } from '@angular/core';
import { Program } from 'app/interfaces/program.model';

@Component({
  selector: 'app-program-card-smiley',
  templateUrl: './program-card-smiley.component.html',
  styleUrls: ['./program-card-smiley.component.scss']
})
export class ProgramCardSmileyComponent implements OnInit {
  @Input() program: Program;
  constructor() { }

  ngOnInit() {
  }

}





// WEBPACK FOOTER //
// ./src/app/components/program-card-smiley/program-card-smiley.component.ts